import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function VerifyEmail() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setStatus("error"); return; }
    api.post("/auth/verify-email", { token })
      .then(() => setStatus("ok"))
      .catch(() => setStatus("error"));
  }, [params]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-6" data-testid="verify-page">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        {status === "loading" && (
          <>
            <Loader2 className="mx-auto h-10 w-10 animate-spin text-blue-600" />
            <p className="mt-4 text-sm text-slate-500">{t("verify.checking")}</p>
          </>
        )}
        {status === "ok" && (
          <>
            <CheckCircle2 className="mx-auto h-12 w-12 text-emerald-500" data-testid="verify-ok" />
            <h1 className="mt-4 text-xl font-semibold text-slate-900">{t("verify.okTitle")}</h1>
            <p className="mt-2 text-sm text-slate-500">{t("verify.okBody")}</p>
            <Link to="/productos"><Button className="mt-6" data-testid="verify-continue">{t("verify.goProducts")}</Button></Link>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle className="mx-auto h-12 w-12 text-red-500" data-testid="verify-error" />
            <h1 className="mt-4 text-xl font-semibold text-slate-900">{t("verify.errTitle")}</h1>
            <p className="mt-2 text-sm text-slate-500">{t("verify.errBody")}</p>
            <Link to="/login"><Button variant="outline" className="mt-6">{t("verify.goLogin")}</Button></Link>
          </>
        )}
      </div>
    </div>
  );
}
